module.exports = __webpack_public_path__ + "static/media/aiclub.ca1a9357.jpg";